<template>
  <div>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="checkMac" class="demo-form-inline">
        <el-form-item label="设备名称">
          <el-input v-model="checkMac.serName" placeholder="输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="设备识别码">
          <el-input v-model="checkMac.simId" placeholder="输入设备识别码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="selectMac">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <el-button type="primary" class='commonBtn addGrainMac' icon='el-icon-circle-plus-outline' @click="addGrainMacInfo('setMacInfo')">添加设备</el-button>
          <div class='setMacView' :style="`height:${height-100}px;width:${width-60}px`">
            <el-tabs v-model="activeName" type="card" :before-leave='emptyMacList' @tab-click="setMacTypeInfo" class='delmarg'>
              <el-tab-pane label="4G分机" name="macType1" class='tab1'>
                <div class='commonWareList' :style="`height:${height-192}px`">
                  <div class='commonItem setGrainMac' v-for='item in setGrainMacList' :key='item.serId'>
                    <div class='setTips'>4G</div>
                    <div class='setGrainMacImg extension'></div>
                    <div class='setGrainMacName'>{{item.serName}}</div>
                    <div class='setGrainMacWareName'><div class='setGrainMacWareNameTitle'>关联仓房：</div><div class='grainWareNameList'><span v-for='(event,index) in item.wareNameVoList' :key='index'>{{event.wareName}}</span></div></div>
                    <div class='setMacBtnList'>
                      <el-row>
                        <el-button type="primary" icon="el-icon-edit" circle class='setAirBtn' @click='getGrainMacInfo(item.serId)'></el-button>
                        <el-button type="danger" icon="el-icon-delete" circle class='setAirBtn' @click='deleteGrainMac(item.serId)'></el-button>
                      </el-row>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="4G主机" name="macType2">
                <div class='commonWareList' :style="`height:${height-192}px`">
                  <div class='commonItem setGrainMac' v-for='item in setGrainMacList' :key='item.serId'>
                    <div class='setTips'>4G</div>
                    <div class='setGrainMacImg host'></div>
                    <div class='setGrainMacName'>{{item.serName}}</div>
                    <div class='setMacBtnList'>
                      <el-row>
                        <el-button type="primary" icon="el-icon-edit" circle class='setAirBtn' @click='getGrainMacInfo(item.serId)'></el-button>
                        <el-button type="danger" icon="el-icon-delete" circle class='setAirBtn' @click='deleteGrainMac(item.serId)'></el-button>
                      </el-row>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="4G气象站" name="macType3">
                <div class='commonWareList' :style="`height:${height-192}px`">
                  <div class='commonItem setGrainMac' v-for='item in setGrainMacList' :key='item.serId'>
                    <div class='setTips'>4G</div>
                    <div class='setGrainMacImg weather'></div>
                    <div class='setGrainMacName'>{{item.serName}}</div>
                    <div class='setMacBtnList'>
                      <el-row>
                        <el-button type="primary" icon="el-icon-edit" circle class='setAirBtn' @click='getGrainMacInfo(item.serId)'></el-button>
                        <el-button type="danger" icon="el-icon-delete" circle class='setAirBtn' @click='deleteGrainMac(item.serId)'></el-button>
                      </el-row>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :hide-on-single-page='true'
              :pageSize='checkMac.pageSize' 
              :current-page='checkMac.pageNum'
              @current-change='getOtherMac'
              class='setPosition'>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="设备基本信息" :visible.sync="dialogTableVisible"
      :close-on-click-modal='false'
      :before-close="handleClose"
      :custom-class='"dialog-setBg dialog-setMacSize"'>
      <div class='formWrap'>
        <el-form ref="setMacInfo" :model="setMacInfo" label-width="100px" :rules='saveMacInfoRules'>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>设备基本信息</div>
          <div class='dialog-setWrap dialog-setWrap-grainMac'>
            <el-form-item label="设备名称" prop='serName'>
              <el-input v-model="setMacInfo.serName" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="设备识别码" prop='simId' v-if='setMacInfo.stationType!=1||setMacInfo.serType=="DEVBHLW084G"||setMacInfo.serType=="DEVLQSERVER4G"'>
              <el-input v-model="setMacInfo.simId" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="设备类型" prop='serType'>
              <el-select v-model="setMacInfo.serType" :disabled="disabled" placeholder="请选择设备类型" @change='changeMacType'>
                <el-option :label="item.serTypeName" :value='item.serTypeValue' v-for='item in macTypeList' :key='item.serTypeValue'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="气象站类型" prop='stationType' v-if='setMacInfo.serType==5' @change="stationChange">
              <el-select v-model="setMacInfo.stationType" placeholder="请选择气象站类型">
                <el-option :label="item.serType" :value='item.serTypeCode' v-for='item in stationTypeList' :key='item.serTypeCode'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地区编码" v-if='setMacInfo.stationType==1&&setMacInfo.serType==5'>
              <el-input v-model="setMacInfo.code" disabled @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="详细地址" v-if='setMacInfo.stationType==1&&setMacInfo.serType==5'>
              <el-input v-model="setMacInfo.address"><el-button slot="append" icon="el-icon-search" @click='searchAddress'></el-button></el-input>
            </el-form-item>
            <el-form-item label="分组数" prop='group' v-if='setMacInfo.serType=="DEVBHLW084G"'>
              <el-select v-model="setMacInfo.group" placeholder="请选择分组数" @change='setGroupInfo'>
                <el-option :label="item" :value='item' v-for='item in groupList' :key='item'></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if='setMacInfo.group&&setMacInfo.serType=="DEVBHLW084G"'>
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>分组使用信息</div>
            <div class='dialog-setWrap dialog-setWrap-grainMac'>
              <el-form-item 
                :label="`第 ${index+1} 组`" 
                v-for='(item,index) in groupInfoList' 
                :key='index'
                class="setConfig">
                <el-select 
                  clearable 
                  v-model="item.wareId" 
                  placeholder="请选择使用该组的仓房" 
                  @change='((val)=>{setWareHouseList(val,index)})'>
                  <el-option 
                    :label="ware.wareName" 
                    :value='ware.wareId' 
                    v-for='ware in setMacWareList'
                    :disabled="ware.disabled" 
                    :key='ware.wareId'>
                  </el-option>
                </el-select>
                <div class="configBtn" v-if='!isAdd' @click="setConfig(item.wareId)">测温配置</div>
              </el-form-item>
            </div>
          </div>
          <div v-if='setMacInfo.serType=="DEVLQSERVER4G"'>
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>关联设备信息<div class='addNomalMac'><span @click='addNomalExtension("nomalMacInfo")'>+分机</span><span @click='addNomalweatherStation("nomalMacInfo")'>+气象站</span></div></div>
            <div class='dialog-setWrap dialog-setWrap-nomalGrainMac' v-if='hostBindMac.length>0'>
              <div class='commonItem setNomalGrainMac' v-for='item in hostBindMac' :key='item.serId' @click="getNomalGrainMac(item.serId)">
                <span class="el-icon-circle-close delNomalMac" @click.stop="deleteNomalMac(item.serId)"></span>
                <div :class='["setGrainMacImg",item.serType==3?"extension":"weather"]'></div>
                <div class='setGrainMacName'>{{item.serName}}</div>
              </div>
            </div>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveMacInfo('setMacInfo')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      width="740px"
      :title="`普通${innerTitle}信息`"
      :visible.sync="innerVisible"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg"'>
      <div class='formWrap'>
        <el-form ref="nomalMacInfo" :model="nomalMacInfo" label-width="100px" :rules='saveNomalMacInfoRules'>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>设备基本信息</div>
          <div class='dialog-setWrap dialog-setWrap-grainMac'>
            <el-form-item label="设备名称" prop='serName'>
              <el-input v-model="nomalMacInfo.serName" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="仓房号" v-if='innerTitle=="气象站"' prop='sensorNum'>
              <el-input v-model="nomalMacInfo.sensorNum" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="分机地址" prop='serNo'>
              <el-input v-model="nomalMacInfo.serNo" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="分组数" prop='group' v-if='innerTitle=="分机"'>
              <el-select v-model="nomalMacInfo.group" placeholder="请选择分组数" @change='setNomalGroupInfo'>
                <el-option :label="item" :value='item' v-for='item in groupList' :key='item'></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if='nomalMacInfo.group&&innerTitle=="分机"'>
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>分组使用信息</div>
            <div class='dialog-setWrap dialog-setWrap-grainMac'>
              <el-form-item 
                :label="`第 ${index+1} 组`" 
                v-for='(item,index) in nomalGroupInfoList' 
                class="setConfig"
                :key='index'>
                <el-select 
                  v-model="item.wareId" 
                  clearable 
                  placeholder="请选择使用该组的仓房" 
                  @change='((val)=>{setNomalWareHouseList(val,index)})'>
                  <el-option 
                    :label="ware.wareName" 
                    :value='ware.wareId' 
                    v-for='ware in setMacWareList'
                    :disabled="ware.disabled" 
                    :key='ware.wareId'>
                  </el-option>
                </el-select>
                <div class="configBtn" @click="setConfig(item.wareId)" v-if='!isNomalAdd'>测温配置</div>
              </el-form-item>
            </div>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveNomalMacInfo('nomalMacInfo')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      width="740px"
      title="测温配置"
      :visible.sync="tempConfigShow"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg dialog-setBg2"'>
      <div class='formWrap'>
        <el-form ref="tempConfig" :model="tempConfig" label-width="100px">
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>测温电缆配置</div>
          <div class='dialog-setWrap dialog-setWrap-grainMac' v-if='tempConfig.wareType=="0"'>
            <el-form-item label="识别模式">
              <el-select v-model="tempConfig.discernMode" placeholder="请选择识别模式">
                <el-option 
                  :label="item.label" 
                  :value="item.value" 
                  v-for='item in dict.type.discern_mode' 
                  :key='item.dictCode'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线制类型">
              <el-select v-model="tempConfig.wireType" placeholder="请选择线制类型">
                <el-option 
                  :label="item.label" 
                  :value="item.value" 
                  v-for='item in dict.type.wire_type' 
                  :key='item.dictCode'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="温湿度地址">
              <el-input v-model.number="tempConfig.sensorNum" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item 
              v-if="tempConfig.discernMode==2||tempConfig.discernMode==5"
              :label="tempConfig.discernMode==2?'起始根号':'起始列号'">
              <el-input v-model.number="tempConfig.sensorStartNum" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="电缆层数">
              <el-input v-model.number="tempConfig.mirLayer" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="电缆行数">
              <el-input v-model.number="tempConfig.mirRow" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="电缆列数">
              <el-input v-model.number="tempConfig.mirColumn" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="粮温校正">
              <el-select v-model="tempConfig.autoCorrection" placeholder="请选择校正类型">
                <el-option 
                  :label="item.label" 
                  :value="item.value" 
                  v-for='item in dict.type.auto_correction' 
                  :key='item.dictCode'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label='通道解锁' style="width:50%">
              <el-switch
                v-model="tempConfig.chUnlock"
                active-value='1'
                inactive-value='0'
                active-text="解锁"
                inactive-text="锁定">
              </el-switch>
            </el-form-item>
            <el-form-item label='水分检测' style="width:50%">
              <el-switch
                v-model="tempConfig.waterChk"
                active-value='1'
                inactive-value='0'
                active-text="启用"
                inactive-text="禁用">
              </el-switch>
            </el-form-item>
            <el-form-item label="镜像设置">
              <el-checkbox v-model="tempConfig.imageLayer" :true-label='1' :false-label='0'>层镜像</el-checkbox>
              <el-checkbox v-model="tempConfig.imageRow" :true-label='1' :false-label='0'>行镜像</el-checkbox>
              <el-checkbox v-model="tempConfig.imageColumn" :true-label='1' :false-label='0'>列镜像</el-checkbox>
            </el-form-item>
          </div>
          <div class='dialog-setWrap dialog-setWrap-grainMac' v-if="tempConfig.wareType=='1'">
            <el-form-item label="识别模式">
              <el-select v-model="tempConfig.discernMode" placeholder="请选择识别模式">
                <el-option 
                  :label="item.label" 
                  :value="item.value" 
                  v-for='item in dict.type.discern_mode' 
                  :key='item.dictCode'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线制类型">
              <el-select v-model="tempConfig.wireType" placeholder="请选择线制类型">
                <el-option 
                  :label="item.label" 
                  :value="item.value" 
                  v-for='item in dict.type.wire_type' 
                  :key='item.dictCode'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="温湿度地址">
              <el-input v-model="tempConfig.sensorNum" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item 
              v-if="tempConfig.discernMode==2||tempConfig.discernMode==5"
              :label="tempConfig.discernMode==2?'起始根号':'起始列号'">
              <el-input v-model="tempConfig.sensorStartNum" @input='$forceUpdate()'></el-input>
            </el-form-item>
            <el-form-item label="每圈层数">
              <el-input v-model="tempConfig.layoutMode" @input='$forceUpdate()' placeholder="用'-'隔开，例如：1-2-3"></el-input>
            </el-form-item>
            <el-form-item label="布线规则">
              <el-input v-model="tempConfig.coilRule" @change='coilRuleChange' placeholder="用'-'隔开，例如：1-2-3"></el-input>
            </el-form-item>
            <el-form-item label="粮温校正">
              <el-select v-model="tempConfig.autoCorrection" placeholder="请选择校正类型">
                <el-option 
                  :label="item.label" 
                  :value="item.value" 
                  v-for='item in dict.type.auto_correction' 
                  :key='item.dictCode'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label='通道解锁'>
              <el-switch
                v-model="tempConfig.chUnlock"
                active-value='1'
                inactive-value='0'
                active-text="解锁"
                inactive-text="锁定">
              </el-switch>
            </el-form-item>
            <el-form-item label='水分检测'>
              <el-switch
                v-model="tempConfig.waterChk"
                active-value='1'
                inactive-value='0'
                active-text="启用"
                inactive-text="禁用">
              </el-switch>
            </el-form-item>
            <el-form-item label="镜像设置">
              <el-checkbox v-model="tempConfig.imageLayer" true-label='1' false-label='0'>层镜像</el-checkbox>
            </el-form-item>
          </div>
          <div class='baseInfoTitle' style="padding-top:10px" v-if='tempConfig.waterChk=="1"'><span></span>水分电缆配置</div>
          <div class='dialog-setWrap dialog-setWrap-grainMac' v-if='tempConfig.waterChk=="1"'>
            <el-form-item label="查看电缆分布">
              <el-switch v-model="waterShow"></el-switch>
            </el-form-item>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveTempConfig('tempConfig')">保存到分机</el-button>
            <el-button type="primary" @click="readMacInfo">读取分机配置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      width="740px"
      title="水分电缆分布信息"
      :visible.sync="waterShow"
      top='120px'
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg"'>
      <div class='formWrap'>
        <div class='formBox'>
          <div class='dialog-setWrap waterWrap'>
            <div class='waterCard' v-if='tempConfig.wareType!=1'>
              <div v-for='lie in tempConfig.mirColumn' :key='lie' class='waterLie' :style='`width:${678/tempConfig.mirColumn}px`'>
                <div 
                  v-for='gen in tempConfig.mirRow' 
                  :key='gen' 
                  class="waterGen"
                  :style='`height:${398/tempConfig.mirRow}px`'
                  @click='setMark((lie-1)*tempConfig.mirRow+gen)'>
                    <div :class='["genhao",markStatus((lie-1)*tempConfig.mirRow+gen)]'>
                      <div class='waterbianhao waterbianhao1' v-if='allWater'>
                        {{(lie-1)*tempConfig.mirRow+gen}}
                      </div>
                      <div class='waterbianhao waterbianhao2' v-else>
                        {{getBianhao((lie-1)*tempConfig.mirRow+gen)!=='false'?tempConfig.waterConfigs[getBianhao((lie-1)*tempConfig.mirRow+gen)].waterGen:''}}
                      </div>
                      <div :style='`margin-top:10px`'>第{{(lie-1)*tempConfig.mirRow+gen}}根</div>
                    </div>
                  </div>
              </div>
            </div>
            <div class='siloCard' v-else>
              <div 
                class='siloquanCard' 
                v-for="quan in siloFenbu.length" 
                :key='quan'
                :style='`width:${(500/siloFenbu.length)*(quan-1)}px;height:${(500/siloFenbu.length)*(quan-1)}px;z-index:${100-quan};}`'>
                <div
                  :class='["siloGenWrap",markStatus(setgenhao(quan)+gen)]' 
                  v-for='gen in Number(siloFenbu[quan-1])' 
                  :key='`gen${gen}`'
                  @click='setMark(setgenhao(quan)+gen)' 
                  :style='`transform: rotate(${(360/Number(siloFenbu[quan-1]))*(gen-1)}deg);transform-origin: 25px ${(250/siloFenbu.length)*(quan-1)+25}px;`'>
                  <div v-if='allWater'>{{setgenhao(quan)+gen}}</div>
                  <div v-else>
                    {{getBianhao(setgenhao(quan)+gen)!=='false'?tempConfig.waterConfigs[getBianhao(setgenhao(quan)+gen)].waterGen:''}}
                  </div>
                  <div style='font-size:12px'>第{{setgenhao(quan)+gen}}根</div>
                </div>
              </div>
            </div>
          </div>
          <div class='tips'>蓝色背景是水分电缆标识，点击根号可以标注为水分电缆</div>
          <div class='saveBtn'>
            <el-button @click='setAllWater'>标注全部</el-button>
            <el-button type="primary" class='sureWater' @click='waterShow=false'>确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="水分电缆信息" :visible.sync="showCode"
      :close-on-click-modal='false'
      width='440px'
      :custom-class='"dialog-setBg"'>
      <div class='formWrap'>
        <el-form 
          label-width="110px" 
          :model='waterCodeObj'
          ref='waterCodeObj'>
          <div class='dialog-setWrap' style="width:700px;flex-wrap:wrap">
            <div>
              <el-form-item 
                :rules="[
                  {required: true, message: '电缆编号不能为空'},
                  { type: 'number', message: '电缆编号必须为数字值'}
                ]"
                prop='waterGen'
                label="水分电缆编号">
                <el-input v-model.number="waterCodeObj.waterGen"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="setWaterCode('waterCodeObj')">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number,
  },
  dicts:['wire_type','auto_correction','water_mode','discern_mode'],
  data(){
    return{
      checkMac:{
        serName:'',
        simId:'',
        pageSize:15,
        pageNum:1,
        isAsc:'desc',
        orderByColumn:'serId',
        serType:'DEVBHLW084G'
      },
      setMacInfo:{
        serType:'DEVBHLW084G',
        code:''
      },
      activeName:'macType1',
      total:0,
      dialogTableVisible:false,
      innerVisible:false,
      setGrainMacList:[],
      setMacWareList:[],
      groupList:[1,2,4,8],
      groupInfoList:[],
      nomalGroupInfoList:[],
      hostBindMac:[],
      macTypeList:[{
        serTypeName:'4G分机',
        serTypeValue:"DEVBHLW084G"
      },{
        serTypeName:'4G主机',
        serTypeValue:"DEVLQSERVER4G"
      },{
        serTypeName:'4G气象站',
        serTypeValue:"5"
      }],
      stationTypeList:[{
        serType:'实体设备',
        serTypeCode:'0'
      },{
        serType:'虚拟设备',
        serTypeCode:'1'
      }],
      saveMacInfoRules:{
        serName:[{trigger:'blur',message:'设备名称不能为空',required:true}],
        simId:[{trigger:'blur',message:'设备识别码不能为空',required:true}]
      },
      saveNomalMacInfoRules:{
        serName:[{trigger:'blur',message:'设备名称不能为空',required:true}],
        sensorNum:[{trigger:'blur',message:'请输分机地址',required:true}],
        serNo:[{trigger:'blur',message:'请输入气象站地址',required:true}]
      },
      isAdd:false,
      loading:false,
      loading2:false,
      isNomalAdd:false,
      innerTitle:'',
      nomalMacInfo:{},
      disabled:false,
      isSwitch:false,
      tempConfig:{},
      tempConfigShow:false,
      waterShow:false,
      allWater:false,
      showCode:false,
      waterCodeObj:{
        waterGen:null,
        gen:null
      },
      siloFenbu:[],
    }
  },
  created(){
    axios.get('/system/ser/getSerType').then(res=>{
      if(res){
        if(res.data.fExist){
          this.activeName='macType1';
          this.checkMac.serType='DEVBHLW084G';
          this.setMacInfo.serType='DEVBHLW084G';
        }else if(res.data.hostExist){
          this.activeName='macType2';
          this.checkMac.serType='DEVLQSERVER4G';
          this.setMacInfo.serType='DEVLQSERVER4G';
        }else if(res.data.weatherExist){
          this.activeName='macType3';
          this.checkMac.serType='5';
          this.setMacInfo.serType='5';
        }else{
          this.$message({
            type: 'warning',
            message: '暂无4G设备，请添加设备!',
            duration:2000
          });
        }
        this.lookupMac();
      }
    });
    this.getWareList()
  },
  computed:{
    markStatus:function() {
      return (val)=>{
        if(this.findSome(val)){
          return 'waterMark'
        }else{
          return ''
        }
      }
    },
    getBianhao:function(){
      return (val)=>{
        if(this.findSome(val)){
          return this.delSome(val,1)
        }
        return 'false'
      }
    },
    setgenhao:function(){
      return (val)=>{
        let num=0;
        if(val>1){
          for(let i=0;i<val-1;i++){
            num+=Number(this.siloFenbu[i])
          }
        }
        return num
      }
    }
  },
  methods:{
    selectMac(){
      this.lookupMac(true);
      this.isSwitch=true
    },
    lookupMac(){
      axios.get('/system/ser/list',{params:this.checkMac}).then(res=>{
        if(res.code==200){
          let data=res.rows;
          this.setGrainMacList=res.rows;
          this.total=res.total;
        }
      })
      
    },
    setGroupInfo(num){
      this.groupInfoList=this.setGroupList(num);
      console.log(this.groupInfoList)
      this.$forceUpdate();
    },
    setWareHouseList(val,index){
      if(val==''){
        this.setMacWareList.forEach(item=>{
          if(item.wareName==this.groupInfoList[index].wareName){
            item.disabled=false
          }
        })
      }else{
        this.setMacWareList.forEach(item=>{
          if(item.wareId==val){
            item.disabled=true;
            this.groupInfoList[index].wareName=item.wareName
          }
        })
      }
      this.$forceUpdate()
    },
    setNomalWareHouseList(val,index){
      if(val==''){
        this.setMacWareList.forEach(item=>{
          if(item.wareName==this.nomalGroupInfoList[index].wareName){
            item.disabled=false
          }
        })
      }else{
        this.setMacWareList.forEach(item=>{
          if(item.wareId==val){
            item.disabled=true;
            this.nomalGroupInfoList[index].wareName=item.wareName
          }
        })
      }
      this.$forceUpdate()
    },
    setNomalGroupInfo(num){
      this.nomalGroupInfoList=this.setGroupList(num,'nomal')
      this.$forceUpdate()
    },
    setGroupList(num,nomal){
      let arr=[];
      for(let i=0;i<num;i++){
        arr.push({useGroup:i+1})
        if(nomal){
          if(this.nomalMacInfo.wareHouseList){
            this.nomalMacInfo.wareHouseList.forEach(item=>{
              if(item.useGroup==i+1){
                arr.fill(item,i,i+1)
              }
            })
          }
        }else{
          if(this.setMacInfo.wareHouseList){
            this.setMacInfo.wareHouseList.forEach(item=>{
              if(item.useGroup==i+1){
                arr.fill(item,i,i+1)
              }
            })
          }
        }
      }
      return arr;
    },
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        let data=res.data;
        data.forEach(item=>{
          if(item.isCheck==1){
            item.disabled=true
          }
        })
        this.setMacWareList=data;
      })
    },
    emptyMacList(activeName, oldActiveName){
      if(this.isSwitch){
        this.isSwitch=false
      }else{
        this.setGrainMacList=[];
      }
    },
    // 关闭弹窗
    handleClose(done){
      this.hostBindMac=[];
      this.setMacWareList.forEach(event=>{
        event.disabled =false
      })
      done()
    },
    handleNomalClose(done){
      this.setMacWareList.forEach(event=>{
        event.disabled =false
      })
      done()
    },
    // 切换设备类型
    changeMacType(val){
      this.$forceUpdate();
      if(val=='DEVLQSERVER4G'){
        this.setMacInfo.serIds=[]
      }
    },
    stationChange(){
      this.$forceUpdate();
    },
    // 切换分页
    getOtherMac(val){
      this.checkMac.pageNum=val;
      this.lookupMac()
    },
    //添加4G设备
    addGrainMacInfo(obj){
      this.dialogTableVisible=true;
      this.isAdd=true;
      this.setMacInfo={}
      this.disabled=false;
      if(this.activeName=='macType1'){
        this.setMacInfo.serType='DEVBHLW084G'
        this.getWareList()
      }else if(this.activeName=='macType2'){
        this.setMacInfo.serType='DEVLQSERVER4G'
        this.getWareList()
      }else{
        this.setMacInfo.serType='5'
      }
    },
    // 修改4G设备
    getGrainMacInfo(serId){
      axios.get(`/system/ser/${serId}`).then(data=>{
        if(data){
          this.setMacInfo=data.data;
          this.dialogTableVisible=true;
          this.isAdd=false;
          this.disabled=true;
          if(data.data.serType=='DEVBHLW084G'){
            this.setGroupInfo(data.data.group)
            this.getWareList()
          }else if(data.data.serType=='DEVLQSERVER4G'){
            this.getHostInfo();
            this.setMacInfo.serIds=[];
          }
        }
      })
    },
    // 删除4G设备
    deleteGrainMac(serId){
      this.$confirm('此操作将永久删除该设备, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/system/ser/delete/${serId}`).then(data=>{
          if(data){
            this.lookupMac()
            this.$message({
              type: 'success',
              message: '删除成功!',
              duration:1000
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration:1000
        });          
      });
    },
    setMacTypeInfo(event){
      this.total=0;
      if(event.index==0){
        this.checkMac.serType='DEVBHLW084G';
        this.checkMac.pageNum=1;
      }else if(event.index==1){
        this.checkMac.serType='DEVLQSERVER4G';
        this.checkMac.pageNum=1;
      }else if(event.index==2){
        this.checkMac.serType=5;
        this.checkMac.pageNum=1;
      }
      this.lookupMac()
    },
    //查询主机下关联的设备
    getHostInfo(){
      axios.get('/system/ser/getHostInfo',{params:{serId:this.setMacInfo.serId}}).then(res=>{
        if(res){
          this.hostBindMac=res.data.serIds
        }
      })
    },
    addNomalweatherStation(obj){
      this.innerTitle='气象站';
      this.innerVisible=true;
      this.isNomalAdd=true;
      if(JSON.stringify(this.nomalMacInfo)!=='{}'){
        this.$refs[obj].resetFields();
        this.nomalMacInfo={}
      }
    },
    addNomalExtension(obj){
      this.innerTitle='分机';
      this.innerVisible=true;
      this.isNomalAdd=true;
      if(JSON.stringify(this.nomalMacInfo)!=='{}'){
        this.$refs[obj].resetFields();
        this.nomalMacInfo={}
      }
    },
    getNomalGrainMac(serId){
       axios.get(`/system/ser/${serId}`).then(data=>{
        if(data){
          this.nomalMacInfo=data.data;
          this.innerVisible=true;
          this.isNomalAdd=false;
          if(data.data.serType==3){
            this.innerTitle='分机';
            this.setNomalGroupInfo(data.data.group);
            this.getWareList()
          }else{
            this.innerTitle='气象站';
          }
        }
      })
    },
    deleteNomalMac(serId){
      this.$confirm('此操作将永久删除该设备, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/system/ser/delete/${serId}`).then(data=>{
          if(data){
            this.getHostInfo();
            this.$message({
              type: 'success',
              message: '删除成功!',
              duration:1000
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration:1000
        });   
      });
    },
    // 设置加载动画
    setMacLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-setBg')
      })
    },
    setMacLoading2(){
      this.loading2=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-setBg2')
      })
    },
    searchAddress(){
      axios.get('/system/station/queryAdcode',{params:{addr:this.setMacInfo.address}}).then(res=>{
        if(res){
          this.setMacInfo.code=res.msg;
        }
      })
    },
    //保存4G设备信息
    saveMacInfo(obj){
      this.$refs[obj].validate((valid)=>{
        if(valid){
          let config=this.setMacInfo;
          let params={};
          this.setMacLoading();
          if(this.isAdd){
            params={
              serName:config.serName,
              simId:config.simId,
              serType:config.serType
            }
            if(config.serType=='DEVBHLW084G'){
              params.group=config.group;
              let arr=[]
              this.groupInfoList.forEach(item=>{
                if(item.wareId){
                  arr.push(item)
                }
              })
              params.wareHouseList=arr;
              axios.post('/system/ser',params).then(data=>{
                if(data){
                  this.checkMac.pageNum=1;
                  this.checkMac.serType='DEVBHLW084G';
                  this.activeName='macType1'
                  axios.post('/system/ser/saveConfig',{serId:data.serId}).then(res=>{
                    this.loading.close();
                    this.dialogTableVisible=false;
                    this.lookupMac();
                    if(res){
                      this.$message({
                        type: 'success',
                        message: '添加成功!',
                        duration:1000
                      });
                    }
                  })
                }else{
                  this.loading.close();
                }
              })
            }else if(config.serType=='DEVLQSERVER4G'){
              params.serIds=config.serIds;
              axios.post('/system/ser',params).then(data=>{
                this.loading.close();
                if(data){
                  this.checkMac.pageNum=1;
                  this.checkMac.serType='DEVLQSERVER4G';
                  this.activeName='macType2'
                  this.$message({
                    type: 'success',
                    message: '添加成功!',
                    duration:1000
                  });
                  this.dialogTableVisible=false;
                  this.lookupMac();
                }
              })
            }else{
              params.stationType=config.stationType;
              params.code=config.code;
              params.address=config.address;
              axios.post('/system/ser',params).then(data=>{
                this.loading.close();
                if(data){
                  this.checkMac.pageNum=1;
                  this.checkMac.serType='5';
                  this.activeName='macType3'
                  this.$message({
                    type: 'success',
                    message: '添加成功!',
                    duration:1000
                  });
                  this.dialogTableVisible=false;
                  this.lookupMac();
                }
              })
            }
          }else{
            params=this.setMacInfo;
            if(this.setMacInfo.serType=='DEVBHLW084G'){
              let arr=[]
              this.groupInfoList.forEach(item=>{
                if(item.wareId){
                  arr.push(item)
                }
              })
              params.wareHouseList=arr;
              axios.put('/system/ser',params).then(data=>{
                if(data){
                  axios.post('/system/ser/saveConfig',{serId:params.serId}).then(res=>{
                    this.loading.close();
                    this.lookupMac();
                    this.dialogTableVisible=false;
                    if(res){
                      this.$message({
                        type: 'success',
                        message: '修改成功!',
                        duration:1000
                      });
                    }
                  })
                }else{
                  this.loading.close()
                }
              })
            }else{
              axios.put('/system/ser',params).then(data=>{
                this.loading.close()
                if(data){
                  this.lookupMac();
                  this.$message({
                    type: 'success',
                    message: '修改成功!',
                    duration:1000
                  });
                  this.dialogTableVisible=false
                }
              })
            }
          }
        }else{
          return false
        }
      })
    },
    //保存普通设备信息
    saveNomalMacInfo(obj){
      this.$refs[obj].validate((valid)=>{
        if(valid){
          let config=this.nomalMacInfo;
          let params={};
          this.setMacLoading()
          if(this.isNomalAdd){
            params={
              serName:config.serName,
              simId:config.simId,
              parentId:this.setMacInfo.serId,
              serNo:config.serNo
            }
            if(this.innerTitle=='分机'){
              params.serType='3';
              params.group=config.group;
              let arr=[]
              this.nomalGroupInfoList.forEach(item=>{
                if(item.wareId){
                  arr.push(item)
                }
              })
              params.wareHouseList=arr;
            }else{
              params.serType='4';
              params.sensorNum=config.sensorNum;
            }
            axios.post('/system/ser',params).then(data=>{
              this.loading.close();
              this.setMacInfo.serIds.push(data.serId);
              if(this.isAdd){
                this.hostBindMac.push({serName:params.serName,serType:params.serType,serId:data.serId})
              }else{
                this.getHostInfo();
              }
              this.$message({
                type: 'success',
                message: '添加成功!',
                duration:1000
              });
              this.innerVisible=false
            })
          }else{
            params=this.nomalMacInfo;
            if(this.innerTitle=='分机'){
              let arr=[]
              this.nomalGroupInfoList.forEach(item=>{
                if(item.wareId){
                  arr.push(item)
                }
              })
              params.wareHouseList=arr;
            }
            axios.put('/system/ser',params).then(data=>{
              this.loading.close()
              if(data){
                if(this.isAdd){
                  this.hostBindMac.forEach(item=>{
                    if(item.serId==params.serId){
                      item.serName=params.serName;
                      item.serType=params.serType
                    }
                  })
                }else{
                  this.getHostInfo();
                }
                this.$message({
                  type: 'success',
                  message: '修改成功!',
                  duration:1000
                });
                this.innerVisible=false
              }
            })
          }
        }else{
          return false
        }
      })
    },
    setConfig(wareId){
      if(!wareId){
        this.$message({
          type: 'warnimg',
          message: '该组未分配仓房，请先分配仓房!',
          duration:1000
        });
        return
      }
      axios.get(`/system/house/${wareId}`).then(res=>{
        if(res){
          this.tempConfigShow=true;
          this.tempConfig=res.data;
          if(res.data.coilRule){
            this.siloFenbu=res.data.coilRule.split('-')
          }
        }
      })
    },
    saveTempConfig(obj){
      this.$refs[obj].validate((valid)=>{
        if(valid){
          this.setMacLoading2()
          axios.put('/system/house',this.tempConfig).then(res=>{
            if(res){
              axios.post('/system/ser/saveConfig',{serId:this.setMacInfo.serId,wareId:this.tempConfig.wareId}).then(res=>{
                this.loading2.close();
                if(res){
                  this.$message({
                    type: 'success',
                    message: '保存成功!',
                    duration:1000
                  });
                  this.tempConfigShow=false;
                }
              })
              
            }
          })
        }else{
          return false
        }
      })
    },
    readMacInfo(){
      this.setMacLoading2()
      axios.post('/system/ser/readConfig',{serId:this.tempConfig.serId,wareId:this.tempConfig.wareId}).then(res=>{
        this.loading2.close();
        if(res){
          this.tempConfig=res.data;
        }
      })
    },
    setAllWater(){
      let arr=[];
      let total=0;
      if(this.tempConfig.wareType!=1){
        total=this.tempConfig.mirRow*this.tempConfig.mirColumn
      }else{
        this.siloFenbu.forEach(item=>{
          total+=Number(item)
        })
      }
      for(let i=0;i<total;i++){
        arr.push({
          gen:i+1,
          waterGen:i+1
        })
      }
      this.tempConfig.waterConfigs=arr;
      this.allWater=true;
    },
    findSome(gen){
      let arr=this.tempConfig.waterConfigs?this.tempConfig.waterConfigs:null;
      if(arr){
        const result = arr.findIndex(item=>item.gen === gen)
        if(result != -1){
          return true
        }
        return false
      }else{
        this.tempConfig.waterConfigs=[]
        return false
      }
    },
    delSome(gen,flag){
      let arr=this.tempConfig.waterConfigs?this.tempConfig.waterConfigs:null;
      if(flag){
        let ind=0
        arr.forEach((item,index)=>{
          if(item.gen==gen){
            ind=index
          }
        })
        return ind
      }else{
        arr.forEach((item,index)=>{
          if(item.gen==gen){
            arr.splice(index,1)
          }
        })
        this.tempConfig.waterConfigs=arr
      }
    },
    setMark(val,obj){
      if(this.findSome(val)){
        this.delSome(val);
        this.allWater=false;
      }else{
        this.showCode=true;
        this.waterCodeObj={
          gen:val,
          waterGen:val
        }
      }
    },
    setWaterCode(obj){
      this.$refs[obj].validate((valid)=>{
        if(valid){
          this.showCode=false;
          let waterCodeObj=this.waterCodeObj;
          let obj={
            gen:waterCodeObj.gen,
            waterGen:waterCodeObj.waterGen
          }
          this.tempConfig.waterConfigs.push(obj);
          this.$refs['waterCodeObj'].resetFields()
        }else{
          return false
        }
      })
    },
    coilRuleChange(val){
      this.siloFenbu=val.split('-')
    }
  }
}
</script>

<style>
  .addGrainMac{
    left: 15px;
  }
  .dialog-setMacSize{
    width: 740px !important
  }
  .dialog-setWrap-grainMac{
    flex-wrap: wrap;
    width: 700px;
  }
  .dialog-setWrap-nomalGrainMac{
    padding: 11px 0 0 11px;
    flex-wrap: wrap;
  }
  .dialog-setWrap-grainMac .el-form-item{
    width: 50%
  }
  .setGrainMac{
    margin:10px 10px 8px 8px;
    width: 300px;
    height: 207px;
  }
  .setGrainMacImg{
    height:66px;
    background-size: cover;
  }
  .extension{
    background-image: url('../../assets/grain/extension.png');
    width: 130px;
  }
  .weather{
    width: 85px;
    background-image: url('../../assets/grain/weather.png')
  }
  .host{
    width: 85px;
    background-image: url('../../assets/grain/host.png')
  }
  .setGrainMacName{
    font-size: 14px;
    font-weight: 600;
    margin-top: 5px
  }
  .setGrainMacWareName{
    font-size: 12px;
    font-weight: 600;
    color: rgba(0,0,0,0.35);
    position: absolute;
    left: 5px;
    bottom: 10px;
    line-height: 16px;
    width:200px;
    display: flex;
  }
  .setGrainMacWareNameTitle{
    flex-basis:60px
  }
  .grainWareNameList{
    width: 140px;
    max-height: 32px;
    overflow: auto;
  }
  .grainWareNameList span{
    margin-right: 3px;
    white-space: nowrap
  }
  .setMacBtnList{
    position: absolute;
    bottom: 10px;
    right:10px;
  }
  .addNomalMac{
    position: absolute;
    right: 0;
    color: #3562ff
  }
  .addNomalMac span{
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
  }
  .addNomalMac span:first-child{
    border-right: 1px solid rgba(0,0,0,0.35)
  }
  .setNomalGrainMac{
    margin-bottom: 11px;
    margin-right: 11px;
    width: 75px;
    height: 58px;
    cursor: pointer;
  }
  .setNomalGrainMac .extension{
    height: 21px;
    width: 41px
  }
  .setNomalGrainMac .setGrainMacName{
    font-size: 12px;
    font-weight: 400;
    margin-top:2px
  }
  .setNomalGrainMac .weather{
    width: 27px;
    height: 21px;
  }
  .delNomalMac{
    font-size: 14px;
    position: absolute;
    right: 2px;
    top: 2px;
    color: red
  }
  .setAirBtn{
    margin: 2px !important;
    padding: 5px !important
  }
  .setConfig{
    width: 100% !important;
  }
  .configBtn{
    position: absolute;
    left: 250px;
    top: 0px;
    background-color:#409EFF;
    color: white;
    width: 150px;
    text-align: center;
    border-radius:2px;
    cursor: pointer;
  }
  .formBox{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .waterWrap{
    width: 700px;
    padding: 10px !important;
    display: flex;
    justify-content: center;
    align-items: center
  }
  .waterCard{
    width: 680px;
    height: 400px;
    padding:1px;
    display: flex;
    border-radius: 5px;
    box-sizing: border-box;
  }
  .formWrap .sureWater{
    margin: 10px 0 20px 0;
  }
  .waterLie{
    display: flex;
    flex-direction: column-reverse;
  }
  .waterGen{
    cursor: pointer;
    padding: 5px;
    box-sizing: border-box;
    position: relative;
  }
  .genhao{
    height: 100%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: black;
    font-weight: 600;
    background-color: white;
    box-shadow: 1px 1px 3px rgba(0,0,0,0.35);
    text-align: center
  }
  .waterLie:last-child .waterGen{
    border-right: none
  }
  .waterGen:last-child{
    border-top: none;
  }
  .siloCard{
    height: 500px;
    width: 500px;
    border: 1px solid rgba(0,0,0,0.35);
    border-radius: 50%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(222, 206, 151, 0.53);
  }
  .siloquanCard{
    border: 1px solid white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-color: rgba(222, 206, 151, 0.53);
  }
  .siloGenWrap{
    background-color:#9eacb9;
    height:50px;
    width:50px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 0;
    color: white;
    margin: -20px 0 0 -20px;
    cursor: pointer;
  }
  .waterMark{
    background-color:#61b3ff;
    color: white
  }
  .waterbianhao{
    border-right: 1px solid white;
    border-bottom: 1px solid white;
    height:25px;
    width:30px;
    position: absolute;
    left: 5px;
    top: 5px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center
  }
  .tips{
    font-size: 12px;
    color: #3562FF;
    font-style: italic;
    padding: 5px 5px 0 0;
    box-sizing: border-box
  }
</style>
